// extracted by mini-css-extract-plugin
module.exports = {"thanks-hero-container":"Thanks_thanks-hero-container__8uvpZ","main":"Thanks_main__1FPts","icon-container":"Thanks_icon-container__K5DTZ"};